"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _button = require("../button");

var _button2 = _interopRequireDefault(_button);

var _label = require("./label");

var _label2 = _interopRequireDefault(_label);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isArray = require("lodash/isArray");

var _isArray2 = _interopRequireDefault(_isArray);

var _inputError = require("./inputError");

var _inputError2 = _interopRequireDefault(_inputError);

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _faSquare = require("@fortawesome/fontawesome-free-solid/faSquare");

var _faSquare2 = _interopRequireDefault(_faSquare);

var _faCheckSquare = require("@fortawesome/fontawesome-free-solid/faCheckSquare");

var _faCheckSquare2 = _interopRequireDefault(_faCheckSquare);

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxButtons = function (_React$Component) {
    _inherits(CheckboxButtons, _React$Component);

    function CheckboxButtons(props) {
        _classCallCheck(this, CheckboxButtons);

        var _this = _possibleConstructorReturn(this, (CheckboxButtons.__proto__ || Object.getPrototypeOf(CheckboxButtons)).call(this, props));

        _this.handleChange = function (value) {
            var onChange = _this.props.onChange;

            var values = [].concat(_toConsumableArray(_this.state.values));
            var valuePosition = values.indexOf(value);

            if (valuePosition != -1) {
                values.splice(valuePosition, 1);
            } else {
                values.push(value);
            }

            _this.setState({ values: values }, function () {
                return onChange({ name: _this.props.name, value: values });
            });
        };

        _this.state = {
            values: props.defaultValue || []
        };
        return _this;
    }

    _createClass(CheckboxButtons, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value && (0, _isArray2.default)(nextProps.value)) {
                this.setState({
                    values: nextProps.value
                });
            }
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var values = this.state.values;

            var _props = this.props,
                theme = _props.theme,
                options = _props.options,
                error = _props.error,
                _props$buttonProps = _props.buttonProps,
                defaultColor = _props$buttonProps.defaultColor,
                activeColor = _props$buttonProps.activeColor,
                buttonProps = _objectWithoutProperties(_props$buttonProps, ["defaultColor", "activeColor"]),
                rest = _objectWithoutProperties(_props, ["theme", "options", "error", "buttonProps"]);

            var buttons = options.map(function (option) {
                var isChecked = values.indexOf(option.value) > -1;
                var params = _extends({}, buttonProps, {
                    key: option.value,
                    color: isChecked ? activeColor || theme.checkboxButton.activeColor : defaultColor || theme.checkboxButton.defaultColor,
                    onClick: function onClick() {
                        return _this2.handleChange(option.value);
                    }
                });

                return [_react2.default.createElement(
                    _button2.default,
                    params,
                    _react2.default.createElement(_reactFontawesome2.default, {
                        icon: isChecked ? _faCheckSquare2.default : _faSquare2.default
                    }),
                    " ",
                    option.text
                ), " "];
            });

            return _react2.default.createElement(
                "div",
                null,
                this.props.label && _react2.default.createElement(
                    _label2.default,
                    rest,
                    this.props.label
                ),
                _react2.default.createElement(
                    "div",
                    null,
                    buttons
                ),
                _react2.default.createElement(_inputError2.default, { error: error })
            );
        }
    }]);

    return CheckboxButtons;
}(_react2.default.Component);

CheckboxButtons = (0, _styledComponents.withTheme)(CheckboxButtons);

CheckboxButtons.displayName = "CheckboxButtons";

CheckboxButtons.propTypes = {
    name: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired,
        text: _propTypes2.default.string.isRequired
    })).isRequired,
    defaultValue: _propTypes2.default.array,
    buttonProps: _propTypes2.default.object,
    error: _propTypes2.default.string
};

CheckboxButtons.defaultProps = {
    error: "",
    buttonProps: {}
};

exports.default = CheckboxButtons;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/checkboxButtons.js
// module id = 998
// module chunks = 95715928098905 168707334958949